import { Text } from '@spotify-internal/encore-web';
import styled from 'styled-components';
export const Subhead = styled(Text).attrs({
    variant: 'titleSmall',
    className: 'subhead',
}) `
  display: block;
`;
